var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.format == 'qr')?_c('vue-qr',_vm._b({},'vue-qr',_vm.options,false)):_c('img',{attrs:{"id":_vm.id}})
}
var staticRenderFns = []

export { render, staticRenderFns }